/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ControlInternalServerError
 */
export interface ControlInternalServerError {
    /**
     * 
     * @type {number}
     * @memberof ControlInternalServerError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ControlInternalServerError
     */
    title: string;
    /**
     * 
     * @type {Message}
     * @memberof ControlInternalServerError
     */
    message: Message;
}

/**
 * Check if a given object implements the ControlInternalServerError interface.
 */
export function instanceOfControlInternalServerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ControlInternalServerErrorFromJSON(json: any): ControlInternalServerError {
    return ControlInternalServerErrorFromJSONTyped(json, false);
}

export function ControlInternalServerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlInternalServerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': MessageFromJSON(json['message']),
    };
}

export function ControlInternalServerErrorToJSON(value?: ControlInternalServerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': MessageToJSON(value.message),
    };
}

